import { InteractionChannelAuditRequest } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

export const getDefaultValuesFromInteractionChannel = (
  interactionChannel?: InteractionChannelAuditRequest
) => {
  if (!interactionChannel) {
    return {
      agreement: false,
      channelSelected: undefined,
      channelAuditSelected: undefined,
      dateSelected: undefined,
      timeSelected: undefined,
    };
  }

  const solicitationDate = interactionChannel?.interactionChannelDate;

  return {
    agreement: interactionChannel?.interactionChannelAgreement ?? false,
    channelSelected: interactionChannel?.interactionChannelOptionValue ?? undefined,
    channelAuditSelected: interactionChannel?.interactionChannelAuditId ?? undefined,
    dateSelected: solicitationDate ?? undefined,
    timeSelected: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : undefined,
  };
};
